<template>
  <div class="pl-2 pr-2">
    <b-input-group>
      <b-form-input
        v-model="filter"
        :placeholder="$t('zones.type_to_search')"
      ></b-form-input>
      <b-input-group-append>
        <b-button :disabled="!filter" @click="filter = ''">{{
          $t('vendor.admin.table.search_clear')
        }}</b-button>
      </b-input-group-append>
    </b-input-group>
    <b-table
      :filter="filter"
      :fields="fields"
      :items="zones"
      :tbody-tr-class="rowClass"
      :per-page="perPage"
      :current-page="currentPage"
      show-empty
    >
      <div
        slot="view"
        slot-scope="{ item }"
        class="text-center pointer"
        @click="$emit('on-row-click', item)"
      >
        <i class="icon-eye"></i>
      </div>

      <div
        slot="title"
        slot-scope="{ item }"
        :title="item.isNewMethod ? $t('divisions.new_method') : ''"
      >
        {{ item.title }}
        <i v-if="item.isNewMethod" class="icon-new text-success" />
      </div>

      <div slot="actions" slot-scope="{ item }" class="text-center pointer">
        <i class="icon-trash" @click="$emit('on-remove-click', item)"></i>
        <i class="icon-pencil pl-2" @click="$emit('on-edit-click', item)"></i>
      </div>
    </b-table>

    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="zones.length"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'ZoneTable',

  props: {
    zones: {
      type: Array,
      default() {
        return []
      },
    },

    activeZone: {
      type: Object,
      default() {
        return null
      },
    },
  },

  data() {
    return {
      currentPage: 1,
      perPage: 10,
      filter: null,
      fields: [
        {
          key: 'view',
          label: this.$t('zones.view'),
          class: 'text-center',
        },
        {
          key: 'id',
          label: this.$t('zones.id'),
          sortable: true,
        },
        {
          key: 'title',
          label: this.$t('zones.name'),
          sortable: true,
        },
        {
          key: 'actions',
          label: this.$t('zones.actions'),
          class: 'text-center',
        },
      ],
    }
  },

  methods: {
    rowClass(item) {
      if (!item) return
      if (this.activeZone && item.id === this.activeZone.id)
        return 'table-success'
    },
  },
}
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>
